/* ==========================================================================
   CasMarkt v1.6 — quick view / quick add and the cart drawer's small moves.
   Owner items 9 and 10.

   Nothing here reimplements Spotlight behaviour. Quick view is Spotlight's
   own <quick-add-modal>, quick add is its <product-form>, and the drawer is
   still rendered and refreshed by cart-drawer.js. This file only:
     1. loads quick-add.js / product-form.js on pages whose sections did not
        ask for them (the collection template sets quick_add: "none"),
     2. flashes a success state on the Quick add pill,
     3. staggers the drawer's line items and marks the newest one.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- assets */
  function loadOnce(src, flag) {
    if (!src || document.querySelector('script[data-cm-src="' + flag + '"]')) return;
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.setAttribute('data-cm-src', flag);
    document.head.appendChild(s);
  }

  function ensureCardScripts() {
    var assets = window.CMCardAssets;
    if (!assets) return;

    // <modal-opener> comes from global.js and calls modal.show() the moment it
    // is clicked, so quick-add.js has to be in place before the first hover.
    if (document.querySelector('quick-add-modal') && !window.customElements.get('quick-add-modal')) {
      loadOnce(assets.quickAdd, 'quick-add');
    }
    if (document.querySelector('product-form') && !window.customElements.get('product-form')) {
      loadOnce(assets.productForm, 'product-form');
    }
  }

  /* ------------------------------------------------- quick add: hit feedback */
  var lastVariantId = null;

  function flashButton(button) {
    if (!button) return;
    button.classList.add('cm-act--done');
    window.setTimeout(function () {
      button.classList.remove('cm-act--done');
    }, 1400);
  }

  function onCartUpdate(payload) {
    if (!payload) return;
    lastVariantId = payload.productVariantId ? String(payload.productVariantId) : null;

    if (payload.source === 'product-form' && lastVariantId) {
      var input = document.querySelector(
        '.cm-actions__form input.product-variant-id[value="' + lastVariantId + '"]'
      );
      var slot = input ? input.closest('.cm-actions__slot') : null;
      if (slot) flashButton(slot.querySelector('.cm-act--add'));
    }
    // The drawer re-renders straight after this; markDrawer runs from the
    // observer below once the new markup is in the DOM.
  }

  /* --------------------------------------------------------- the cart drawer */
  function decorateDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var items = drawer.querySelectorAll('.cart-item');
    for (var i = 0; i < items.length; i += 1) {
      items[i].style.setProperty('--cm-i', String(i));
    }

    if (!lastVariantId) return;
    var input = drawer.querySelector('input[data-quantity-variant-id="' + lastVariantId + '"]');
    var row = input ? input.closest('.cart-item') : null;
    if (!row || row.classList.contains('cm-cart-item--added')) return;

    row.classList.add('cm-cart-item--added');
    window.setTimeout(function () {
      row.classList.remove('cm-cart-item--added');
      lastVariantId = null;
    }, 2200);
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof MutationObserver === 'undefined') return;

    var pending = null;
    var observer = new MutationObserver(function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(decorateDrawer, 30);
    });

    observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    decorateDrawer();
  }

  /* --------------------------------------------------------------- start up */
  function init() {
    ensureCardScripts();
    watchDrawer();

    // constants.js declares PUB_SUB_EVENTS with `const`, so it lives in the
    // global lexical scope and never appears on `window` — it has to be read
    // as a bare identifier, behind a typeof guard.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
